import Swiper from "swiper";
import {
  Navigation,
  Grid,
  Autoplay,
  FreeMode,
  Thumbs,
  Pagination,
  EffectFade,
} from "swiper/modules";
import { gsap } from "gsap";

function initializeSwiper() {
  const bannerHomeSwipers = document.querySelectorAll(".swiper-banners");
  bannerHomeSwipers.forEach((swiper) => {
    new Swiper(swiper, {
      modules: [Navigation, EffectFade, Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      effect: "fade",
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      fadeEffect: { crossFade: true },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  });

  const cardapioNovidadesSwipers = document.querySelectorAll(
    ".swiper-novidades-cardapio"
  );
  cardapioNovidadesSwipers.forEach((swiper) => {
    new Swiper(swiper, {
      modules: [Navigation],
      slidesPerView: 1.1,
      spaceBetween: 24,
      navigation: {
        prevEl: ".swiper-novidades-cardapio-wrapper .swiper-button-prev",
        nextEl: ".swiper-novidades-cardapio-wrapper .swiper-button-next",
      },
      breakpoints: {
        480: {
          slidesPerView: 1.55,
        },
        650: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });

  const cardapioMaisVendidosSwipers = document.querySelectorAll(
    ".swiper-mais-vendidos"
  );
  cardapioMaisVendidosSwipers.forEach((swiper) => {
    new Swiper(swiper, {
      modules: [Navigation],
      slidesPerView: 1.1,
      spaceBetween: 24,
      navigation: {
        prevEl: ".swiper-mais-vendidos-wrapper .swiper-button-prev",
        nextEl: ".swiper-mais-vendidos-wrapper .swiper-button-next",
      },
      breakpoints: {
        480: {
          slidesPerView: 1.55,
        },
        650: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });

  // Categorias genéricas (sem ID único) - apenas para compatibilidade com outros templates
  const categoriaSwipers = document.querySelectorAll(".swiper-categorias:not([id^='swiper-categorias-'])");
  categoriaSwipers.forEach((swiper) => {
    if (swiper.swiper) {
      return;
    }
    new Swiper(swiper, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.1,
      spaceBetween: 24,
      pagination: {
        el: ".swiper-categorias-pagination",
        clickable: true,
      },
      breakpoints: {
        480: {
          slidesPerView: 1.55,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });

  const conhecaEmpresaSwipers = document.querySelectorAll(
    ".swiper-conheca-empresa"
  );
  conhecaEmpresaSwipers.forEach((swiper) => {
    new Swiper(swiper, {
      modules: [Navigation, Pagination, EffectFade, Autoplay],
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 1000,
      effect: "fade",
      fadeEffect: { crossFade: true },
      pagination: {
        el: ".swiper-conheca-empresa-pagination",
        clickable: true,
      },
    });
  });

  const depoimentosSwipers = document.querySelectorAll(".swiper-depoimentos");
  depoimentosSwipers.forEach((swiper) => {
    new Swiper(swiper, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: {
        prevEl: ".swiper-depoimentos-wrapper .swiper-button-prev",
        nextEl: ".swiper-depoimentos-wrapper .swiper-button-next",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });

  const sobreNosSwiper = document.querySelector(".swiper-about-galeria");
  if (sobreNosSwiper) {
    // Anima apenas o slide ativo do meio (não duplicado, não prev, não next)
    const animateActiveSlide = function () {
      const allSlides = sobreNosSwiper.querySelectorAll(".swiper-slide");
      allSlides.forEach((slide) => {
        const figure = slide.querySelector("figure");
        if (figure) {
          slide.style.overflow = "";
          slide.style.zIndex = "";
          gsap.set(figure, { scale: 1 });
        }
      });

      const allActiveSlides = sobreNosSwiper.querySelectorAll(
        ".swiper-slide-active"
      );
      const realActiveSlide = Array.from(allActiveSlides).find((slide) => {
        const hasPrev = slide.classList.contains("swiper-slide-prev");
        const hasNext = slide.classList.contains("swiper-slide-next");
        const hasDuplicate = slide.classList.contains("swiper-slide-duplicate");
        return !hasPrev && !hasNext && !hasDuplicate;
      });

      if (realActiveSlide) {
        const activeFigure = realActiveSlide.querySelector("figure");
        if (activeFigure) {
          realActiveSlide.style.overflow = "visible";
          realActiveSlide.style.zIndex = "10";
          gsap.to(activeFigure, {
            scale: 1.1,
            duration: 0.6,
            ease: "power2.out",
          });
        }
      }
    };

    const swiperInstance = new Swiper(sobreNosSwiper, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: true,
      loop: true,
      speed: 800,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      navigation: {
        nextEl: ".swiper-about-galeria-wrapper .swiper-button-next",
        prevEl: ".swiper-about-galeria-wrapper .swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 28,
        },
      },
      on: {
        init: function () {
          animateActiveSlide();
        },
        slideChange: function () {
          const allSlides = sobreNosSwiper.querySelectorAll(".swiper-slide");
          const allFigures = sobreNosSwiper.querySelectorAll(
            ".swiper-slide figure"
          );

          allSlides.forEach((slide) => {
            slide.style.overflow = "";
            slide.style.zIndex = "";
          });

          gsap.to(allFigures, {
            scale: 1,
            duration: 0.5,
            ease: "power2.out",
          });
        },
        slideChangeTransitionEnd: function () {
          requestAnimationFrame(() => {
            animateActiveSlide();
          });
        },
      },
    });
  }

  // Blog Hero Swiper
  const blogHeroSwipers = document.querySelectorAll(".blog-hero-swiper");
  blogHeroSwipers.forEach((swiper) => {
    new Swiper(swiper, {
      modules: [Navigation, Autoplay, EffectFade],
      slidesPerView: 1,
      spaceBetween: 0,
      effect: "fade",
      loop: true,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      fadeEffect: { crossFade: true },
      navigation: {
        prevEl: ".blog-hero-prev",
        nextEl: ".blog-hero-next",
      },
    });
  });

  // Blog Categories Swiper (Mobile only)
  const blogCategoriesSwipers = document.querySelectorAll(
    ".blog-categories-swiper"
  );
  blogCategoriesSwipers.forEach((swiper) => {
    new Swiper(swiper, {
      slidesPerView: 2.2,
      spaceBetween: 16,
      centeredSlides: false,
      breakpoints: {
        480: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  });

  // Categorias com IDs únicos (múltiplas instâncias)
  // Exclui botões de navegação que terminam com -prev ou -next
  const swiperCategorias = document.querySelectorAll(
    '[id^="swiper-categorias-"]:not([id$="-prev"]):not([id$="-next"])'
  );

  swiperCategorias.forEach((swiperEl) => {
    // Verifica se já foi inicializado
    if (swiperEl.swiper) {
      return;
    }

    // Verifica se o elemento tem a classe swiper-categorias (é um container de swiper)
    if (!swiperEl.classList.contains("swiper-categorias")) {
      return;
    }

    // Verifica se o elemento tem a estrutura necessária (swiper-wrapper)
    const wrapper = swiperEl.querySelector(".swiper-wrapper");
    if (!wrapper) {
      return;
    }

    // Verifica se há slides
    const slides = wrapper.querySelectorAll(".swiper-slide");
    if (slides.length === 0) {
      console.warn(`Swiper ${swiperEl.id} não possui slides`);
      return;
    }

    const swiperId = swiperEl.id;
    const btnPrevId = swiperId + "-prev";
    const btnNextId = swiperId + "-next";
    const btnPrev = document.getElementById(btnPrevId);
    const btnNext = document.getElementById(btnNextId);

    const navigationConfig =
      btnPrev && btnNext
        ? {
            prevEl: "#" + btnPrevId,
            nextEl: "#" + btnNextId,
          }
        : false;

    // Função auxiliar para calcular slidesPerView baseado na largura da janela
    const getCurrentSlidesPerView = () => {
      const width = window.innerWidth;
      if (width >= 1024) return 3;
      if (width >= 768) return 2;
      if (width >= 480) return 1.55;
      return 1.1;
    };

    // Função auxiliar para verificar e atualizar visibilidade da navegação
    const updateNavigationVisibility = (swiperInstance) => {
      const navWrapper = swiperEl
        .closest(".swiper-categorias-wrapper")
        ?.querySelector(".swiper-navigation-wrapper");
      
      if (navWrapper) {
        const currentSlidesPerView = swiperInstance.params.slidesPerView || getCurrentSlidesPerView();
        const totalSlides = swiperInstance.slides.length;
        
        if (totalSlides <= currentSlidesPerView) {
          navWrapper.style.display = "none";
        } else {
          navWrapper.style.display = "flex";
        }
      }
    };

    try {
      const swiperInstance = new Swiper(swiperEl, {
        modules: [Navigation],
        slidesPerView: 1.1,
        spaceBetween: 24,
        navigation: navigationConfig,
        observer: true,
        observeParents: true,
        breakpoints: {
          480: {
            slidesPerView: 1.55,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
        on: {
          init: function () {
            updateNavigationVisibility(this);
          },
          resize: function () {
            // Usa requestAnimationFrame para garantir que o resize foi processado
            requestAnimationFrame(() => {
              updateNavigationVisibility(this);
            });
          },
          breakpoint: function () {
            // Atualiza quando muda o breakpoint
            requestAnimationFrame(() => {
              updateNavigationVisibility(this);
            });
          },
        },
      });
    } catch (error) {
      console.error(`Erro ao inicializar swiper ${swiperId}:`, error);
    }
  });
}

export { initializeSwiper };
